import ReactPlayer from 'react-player'

const YouTubeDurationFetcher = ({
  url,
  onDuration,
}: {
  url: string
  onDuration: (duration: number) => void
}) => {
  return (
    <div style={{ position: 'absolute', left: '-9999px' }}>
      <ReactPlayer
        url={url}
        onDuration={onDuration}
        controls={false}
        playing={false}
      />
    </div>
  )
}

export default YouTubeDurationFetcher
